import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { MODELS } from "../content";
import { scrollToId } from "./SmoothScroll";

export const Models = () => (
  <section id="models" className="relative py-28 md:py-40" data-testid="models-section">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <SectionHead
        index="02"
        label="Engagement models"
        title={<>Flexible models for <em className="text-emerald-400">every</em> hiring need.</>}
        sub="Flexible. Scalable. Outcome-driven. Choose how we work together, and we'll shape the search around it."
      />
      <div className="mt-16 grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {MODELS.map((m, i) => (
          <Reveal key={m.t} delay={i * 0.08} className="h-full">
            <motion.div
              whileHover={{ y: -6 }}
              transition={{ type: "spring", stiffness: 260, damping: 22 }}
              className={`group flex h-full flex-col rounded-md border p-7 transition-colors duration-500 ${
                i === 0 ? "border-emerald-400/40 bg-emerald-500/[0.06]" : "border-white/10 bg-[#111519] hover:border-white/25"
              }`}
              data-testid={`model-card-${i}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs text-zinc-400">0{i + 1}</span>
                {i === 0 && <span className="rounded-full bg-emerald-500 px-3 py-1 font-mono text-[10px] uppercase tracking-[0.15em] text-[#0a0c0e]">Flagship</span>}
              </div>
              <p className="font-display mt-10 text-3xl text-zinc-100">{m.t}</p>
              <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-emerald-300">{m.tag}</p>
              <p className="mt-5 text-sm text-zinc-400 leading-relaxed">{m.d}</p>
              <ul className="mt-6 space-y-2.5 border-t border-white/10 pt-6">
                {m.pts.map((p) => (
                  <li key={p} className="flex items-center gap-3 text-sm text-zinc-200">
                    <Check className="h-4 w-4 text-emerald-400" />
                    {p}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => scrollToId("mandate")}
                className="mt-auto pt-10 inline-flex items-center gap-2 text-sm text-zinc-200 hover:text-emerald-300 transition-colors"
                data-testid={`model-cta-${i}`}
              >
                Discuss this model
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </button>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
